import { useParam } from "@blitzjs/next"
import { trpc } from "app/core/trpcClient"
import type { AppRouter } from "app/api-utils/trpc/routers/_app"
import type { inferRouterOutputs } from "@trpc/server"
import { flattenDeep } from "es-toolkit"

type RouterOutput = inferRouterOutputs<AppRouter>
type TPaywallTemplates = RouterOutput["blitzMigration"]["paywalls"]["getPaywallTemplates"]

const useGetPaywallTemplates = (v4Only: boolean, publicTemplates: boolean = false) => {
  const applicationId = useParam("applicationId", "number")!

  const queryResult = publicTemplates
    ? trpc.blitzMigration.paywalls.getPaywallTemplatesPublic.useQuery(
        { take: 250, skip: 0 },
        {
          suspense: false,
        }
      )
    : trpc.blitzMigration.paywalls.getPaywallTemplates.useQuery(
        { take: 250, skip: 0, applicationId, v4Only },
        {
          suspense: false,
        }
      )

  const { data, isFetching, ...queryExtra } = queryResult

  return {
    data: data as TPaywallTemplates,
    isFetching,
    ...queryExtra,
  }
}

export default useGetPaywallTemplates
